export default __webpack_public_path__ + "static/media/pet-images-03.028bd41a.jpg";